export default __webpack_public_path__ + "static/Nerd-b5b8dcdecd5db4f544f499e9367af90f.png";